<template>
    <v-row dense class="mb-4">
        <v-col cols="12" md="2">
            <span class="text-h6 text--secondary">
                {{ $t('key_facts') }}
            </span>
        </v-col>
        <v-col cols="12" md="8">
            <v-autocomplete
                ref="option"
                v-model="contract.airlineCode"
                :items="useAirlines"
                item-title="title"
                item-value="value"
                closable-chips
                hide-details
                clearable
                :label="$t('flights.airline')"
                density="compact"
                color="primary"
                class="mb-4"
                data-cy="airline-code"
            />
            <v-row dense>
                <v-col cols="12" md="6">
                    <div class="text-subtitle-1">{{ `${$t('flights.departure')}*` }}:</div>
                    <airports-search-input
                        v-model="contract.departureCharterLocation.airportCode"
                        :single-line="true"
                        color="primary"
                        variant="outlined"
                        data-cy="departure-airline-code"
                        :rules="[requiredRule('flights.departure')]"
                    />
                </v-col>
                <v-col cols="12" md="6">
                    <div class="text-subtitle-1">{{ `${$t('flights.arrival')}*` }}:</div>
                    <airports-search-input
                        v-model="contract.destinationCharterLocation.airportCode"
                        :single-line="true"
                        color="primary"
                        variant="outlined"
                        data-cy="destination-airline-code"
                        :rules="[requiredRule('flights.arrival')]"
                    />
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>
<script setup lang="ts">
    import {useAirlines} from '~/composables/form-helpers'
    import AirportsSearchInput from '~/components/snippets/AirportsSearchInput.vue'
    import {requiredRule} from '~/composables/rules'

    const contract = defineModel<any>()

    onMounted(async () => {
        await flightsStore.loadAirlines()
    })
</script>

<style scoped lang="scss">
    @use 'vuetify/settings';
    @use 'sass:map';
    :deep(.v-autocomplete__selection) {
        height: fit-content;
    }
</style>
